import { Col as AntdCol, ColProps } from 'antd'

export const Col = (props: ColProps) => <AntdCol {...props} />
